import React from 'react';
import { Navigate, Outlet, useLocation, useParams } from 'react-router-dom';
import { isLocale } from './paths';

const LocaleLayout = () => {
  const { lang } = useParams();
  const { pathname, search, hash } = useLocation();

  if (!isLocale(lang)) {
    return <Navigate to={`/en${pathname}${search}${hash}`} replace />;
  }

  return <Outlet />;
};

export default LocaleLayout;
